"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AUTH_DEFAULT: () => AUTH_DEFAULT,
  AUTH_EVENT_TYPE: () => AUTH_EVENT_TYPE,
  AUTH_METHOD: () => AUTH_METHOD,
  AUTH_TYPE: () => AUTH_TYPE,
  EXPOSURE_ASSIGNMENT_SERVICE: () => EXPOSURE_ASSIGNMENT_SERVICE,
  EXPOSURE_KEY_TYPE: () => EXPOSURE_KEY_TYPE,
  EventTypeStaticDataMapping: () => EventTypeStaticDataMapping,
  ExposureTypeStaticDataMapping: () => ExposureTypeStaticDataMapping,
  IDP: () => IDP,
  INPUT_SELECTOR: () => INPUT_SELECTOR,
  NO_TRIGGER_OBJECT: () => NO_TRIGGER_OBJECT,
  TARGET_DOM_NODE_TYPES: () => TARGET_DOM_NODE_TYPES,
  TRIGGER_OBJECT: () => TRIGGER_OBJECT,
  TRIGGER_TYPE: () => TRIGGER_TYPE,
  UNSPECIFIED: () => UNSPECIFIED,
  domTextScanner: () => domTextScanner,
  getInputSelector: () => getInputSelector_default,
  initializeAuth0Tracking: () => initializeAuth0Tracking,
  isAuth0Prod: () => isAuth0Prod,
  pageView: () => pageView_default,
  sendExposure: () => sendExposure_default,
  trackAuth: () => trackAuth_default
});
module.exports = __toCommonJS(src_exports);

// src/tracking/constants.ts
var AUTH_DEFAULT = "authentication_form";
var NO_TRIGGER_OBJECT = "no_trigger_object";
var UNSPECIFIED = "unspecified";
var TRIGGER_OBJECT = Object.freeze({
  Default: AUTH_DEFAULT,
  NoTriggerObject: NO_TRIGGER_OBJECT
});
var AUTH_METHOD = Object.freeze({
  EmailPassword: "email_pw",
  EmailOTP: "email_otp",
  SMSOTP: "sms_otp",
  VoiceOTP: "voice_otp",
  AppleSSO: "apple_sso",
  FacebookSSO: "facebook_sso",
  GoogleSSO: "google_sso",
  GoogleOneTap: "google_one_tap",
  NA: "n/a"
});
var INPUT_SELECTOR = Object.freeze({
  Mouse: "mouse",
  Keyboard: "keyboard",
  Other: "other"
});
var TRIGGER_TYPE = Object.freeze({
  Interaction: "interaction",
  Impression: "impression",
  View: "view"
});
var IDP = Object.freeze({
  Zillow: "zillow",
  Auth0: "auth0"
});
var AUTH_TYPE = Object.freeze({
  AccountLogin: "account_login",
  AccountRegister: "account_register",
  ProRegister: "pro_register"
});
var EXPOSURE_KEY_TYPE = Object.freeze({
  GUID: "guid",
  ZUID: "zuid"
});
var EXPOSURE_ASSIGNMENT_SERVICE = Object.freeze({
  ABS: "abs",
  SPLIT: "split"
});
var EventTypeStaticDataMapping = Object.freeze({
  // Deprecated. Will be removed in a future version.
  AuthStart: {
    envelope: {
      event_type_id: "3747",
      event_type_version_id: "2",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "auth_start"
    }
  },
  LoginAttempt: {
    envelope: {
      event_type_id: "722",
      event_type_version_id: "10",
      event_template_id: "273",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "account_login_start"
    }
  },
  LoginError: {
    envelope: {
      event_type_id: "41",
      event_type_version_id: "8",
      event_template_id: "273",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject
    },
    semantic: {
      semantic_event_nm: "account_login_error"
    }
  },
  AuthSuccess: {
    envelope: {
      event_type_id: "6675",
      event_type_version_id: "6",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject
    },
    semantic: {
      semantic_event_nm: "account_auth_success"
    }
  },
  RegisterAttempt: {
    envelope: {
      event_type_id: "39",
      event_type_version_id: "10",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "account_register_start"
    }
  },
  RegisterError: {
    envelope: {
      event_type_id: "723",
      event_type_version_id: "7",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject
    },
    semantic: {
      semantic_event_nm: "account_register_error"
    }
  },
  AuthFormClose: {
    envelope: {
      event_type_id: "3065",
      event_type_version_id: "2",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "auth_form_close"
    }
  },
  LightboxContentView: {
    envelope: {
      event_type_id: "724",
      event_type_version_id: "6",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject
    },
    semantic: {
      semantic_event_nm: "view_content"
    }
  },
  AuthPageView: {
    envelope: {
      event_type_id: "701",
      event_type_version_id: "11",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.View,
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject
    },
    semantic: {
      semantic_event_nm: "view_content"
    }
  },
  ForgotPasswordLinkClick: {
    envelope: {
      event_type_id: "2943",
      event_type_version_id: "4",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "forgot_password_open"
    }
  },
  ForgotPasswordRequestSubmit: {
    envelope: {
      event_type_id: "2942",
      event_type_version_id: "4",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "forgot_password_start"
    }
  },
  ForgotPasswordSignIn: {
    envelope: {
      event_type_id: "2941",
      event_type_version_id: "5",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "account_login_open"
    }
  },
  ChangePasswordSubmit: {
    envelope: {
      event_type_id: "6941",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "change_password"
    }
  },
  CheckProRegBox: {
    envelope: {
      event_type_id: "2946",
      event_type_version_id: "3",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "account_pro_register"
    }
  },
  EmailSubmit: {
    envelope: {
      event_type_id: "2947",
      event_type_version_id: "6",
      event_template_id: "273",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "account_email_submit"
    }
  },
  PasswordCreationDefer: {
    envelope: {
      event_type_id: "2948",
      event_type_version_id: "5",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "account_password_creation_defer"
    }
  },
  CreatePassword: {
    envelope: {
      event_type_id: "2950",
      event_type_version_id: "4",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "account_password_create"
    }
  },
  EmailConfirmationPasswordSubmit: {
    envelope: {
      event_type_id: "2972",
      event_type_version_id: "3",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "email_confirmation_password_submit"
    }
  },
  ChangeEmailAddress: {
    envelope: {
      event_type_id: "3854",
      event_type_version_id: "2",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "change_email"
    }
  },
  SelectEmailOTP: {
    envelope: {
      event_type_id: "3855",
      event_type_version_id: "3",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "email_otp_prompt"
    }
  },
  ResendEmailOTPCode: {
    envelope: {
      event_type_id: "3861",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "resend_email_otp_code"
    }
  },
  RequestNewCode: {
    envelope: {
      event_type_id: "6087",
      event_type_version_id: "2",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "request_new_code"
    }
  },
  SwitchAuthType: {
    envelope: {
      event_type_id: "5971",
      event_type_version_id: "3",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "switch_auth_type"
    }
  },
  ResendPasswordResetEmail: {
    envelope: {
      event_type_id: "5975",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "resend_password_reset_email"
    }
  },
  SelectMFAMethod: {
    envelope: {
      event_type_id: "6088",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "select_mfa_method"
    }
  },
  GoToPreviousScreen: {
    envelope: {
      event_type_id: "6089",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "go_to_previous_screen"
    }
  },
  SwitchMFAMethod: {
    envelope: {
      event_type_id: "6153",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "switch_mfa_method"
    }
  },
  GoToMFAChallenge: {
    envelope: {
      event_type_id: "6154",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "go_to_mfa_challenge"
    }
  },
  ChangePhoneNumber: {
    envelope: {
      event_type_id: "6155",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "change_phone"
    }
  },
  OpenTermsOfUse: {
    envelope: {
      event_type_id: "6220",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "open_terms_of_use"
    }
  },
  StartWebauthnEnrollment: {
    envelope: {
      event_type_id: "6221",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "webauthn_enrollment_start"
    }
  },
  SnoozeWebauthnEnrollment: {
    envelope: {
      event_type_id: "6222",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "webauthn_enrollment_snooze"
    }
  },
  DeclineWebauthnEnrollment: {
    envelope: {
      event_type_id: "6223",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "webauthn_enrollment_decline"
    }
  },
  RetryWebauthnEnrollment: {
    envelope: {
      event_type_id: "6224",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "webauthn_enrollment_retry"
    }
  },
  ProRegisterationLinkClick: {
    envelope: {
      event_type_id: "6724",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "pro_registration_link_click"
    }
  },
  ConnectionSwitchLinkClick: {
    envelope: {
      event_type_id: "6749",
      event_type_version_id: "1",
      event_template_id: "5",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction
    },
    semantic: {
      semantic_event_nm: "connection_switch_link_click"
    }
  }
});
var ExposureTypeStaticDataMapping = Object.freeze({
  Exposure: {
    envelope: {
      event_type_id: "7229",
      event_type_version_id: "1",
      event_template_id: "3",
      event_template_version_id: "1"
    },
    semantic: {
      semantic_event_nm: "exposure"
    }
  }
});
var AUTH_EVENT_TYPE = Object.keys(
  EventTypeStaticDataMapping
).reduce((acc, key) => __spreadProps(__spreadValues({}, acc), { [key]: key }), {});

// src/tracking/getInputSelector.ts
function getInputSelector(clickCountOrClientX, clientY) {
  if (clickCountOrClientX !== void 0 && clientY !== void 0) {
    return clickCountOrClientX === 0 && clientY === 0 ? INPUT_SELECTOR.Keyboard : INPUT_SELECTOR.Mouse;
  }
  if (clickCountOrClientX !== void 0) {
    return clickCountOrClientX === 0 ? INPUT_SELECTOR.Keyboard : INPUT_SELECTOR.Mouse;
  }
  return INPUT_SELECTOR.Other;
}
var getInputSelector_default = getInputSelector;

// src/tracking/pageView.ts
var import_universal_analytics = require("@zillow/universal-analytics");

// src/tracking/getEventSpecificProps.ts
var getEventSpecificProps = (authEventType) => EventTypeStaticDataMapping[authEventType];
var getEventSpecificProps_default = getEventSpecificProps;

// src/tracking/getNewLaneProps.ts
var getNewLaneProps = ({
  authEventType,
  unifiedPageComponentProps,
  additionalContextualBlocks
}) => {
  var _a, _b;
  const eventSpecificProps = getEventSpecificProps_default(authEventType);
  return __spreadValues({
    /**
     * All envelope props, except `event_client_start_dtm`, are retrieved from event-specific props by calling `getEventSpecificProps`.
     */
    envelope: __spreadProps(__spreadValues({}, eventSpecificProps.envelope), {
      event_client_start_dtm: (/* @__PURE__ */ new Date()).toISOString()
    }),
    /**
     * Each field is explicitly listed due to different merging logics for these props.
     */
    clickstream_trigger: {
      trigger_type_nm: eventSpecificProps.clickstream_trigger.trigger_type_nm,
      trigger_location_nm: unifiedPageComponentProps.clickstream_trigger.trigger_location_nm,
      trigger_source_nm: (_a = eventSpecificProps.clickstream_trigger.trigger_source_nm) != null ? _a : unifiedPageComponentProps.clickstream_trigger.trigger_source_nm,
      trigger_object_nm: (_b = eventSpecificProps.clickstream_trigger.trigger_object_nm) != null ? _b : TRIGGER_OBJECT.Default,
      input_selector_nm: unifiedPageComponentProps.clickstream_trigger.input_selector_nm
    },
    semantic: __spreadValues({}, eventSpecificProps.semantic),
    /**
     * The `auth_form` block is for dynamically generated authentication metadata.
     * All the props are retrieved from `unifiedPageComponentProps`.
     */
    auth_form: __spreadValues({}, unifiedPageComponentProps.auth_form)
  }, additionalContextualBlocks);
};
var getNewLaneProps_default = getNewLaneProps;

// src/tracking/mergePageComponentProps.ts
var mergePageComponentProps = (pageProps, componentProps) => {
  var _a, _b, _c, _d;
  return {
    clickstream_trigger: {
      trigger_location_nm: pageProps.clickstream_trigger.trigger_location_nm,
      trigger_source_nm: (_b = (_a = componentProps == null ? void 0 : componentProps.clickstream_trigger) == null ? void 0 : _a.trigger_source_nm) != null ? _b : pageProps.clickstream_trigger.trigger_location_nm,
      input_selector_nm: (_d = (_c = componentProps == null ? void 0 : componentProps.clickstream_trigger) == null ? void 0 : _c.input_selector_nm) != null ? _d : INPUT_SELECTOR.Other
    },
    auth_form: __spreadValues(__spreadValues({
      // default to 'n/a' if not provided
      auth_method_cd: AUTH_METHOD.NA,
      // default to 'unspecified' if not provided
      entry_point_nm: UNSPECIFIED
    }, pageProps.auth_form), componentProps == null ? void 0 : componentProps.auth_form)
  };
};
var mergePageComponentProps_default = mergePageComponentProps;

// src/tracking/pageView.ts
var pageView = ({
  pageURL,
  pageSpecificProps,
  additionalContextualBlocks,
  isLightbox = false
}) => {
  const newLaneProps = getNewLaneProps_default({
    authEventType: isLightbox ? AUTH_EVENT_TYPE.LightboxContentView : AUTH_EVENT_TYPE.AuthPageView,
    unifiedPageComponentProps: mergePageComponentProps_default(pageSpecificProps),
    additionalContextualBlocks
  });
  if (isLightbox) {
    (0, import_universal_analytics.event)(newLaneProps);
  } else {
    (0, import_universal_analytics.page)(pageURL, {}, { newLaneEvent: newLaneProps });
  }
};
var pageView_default = pageView;

// src/tracking/trackAuth.ts
var import_universal_analytics2 = require("@zillow/universal-analytics");
var trackAuth = (authEventType) => ({
  /** Page-specific props */
  pageProps,
  /** Component-specific props */
  componentProps,
  /** Additional contextual blocks */
  additionalContextualBlocks,
  /**
   * Legacy GA props
   * @deprecated Need further guidance from the clickstream team on when/how to remove.
   */
  gaProps
}) => {
  const newLaneProps = getNewLaneProps_default({
    authEventType,
    unifiedPageComponentProps: mergePageComponentProps_default(pageProps, componentProps),
    additionalContextualBlocks
  });
  if (gaProps) {
    (0, import_universal_analytics2.track)(__spreadValues({}, gaProps), { newLaneEvent: newLaneProps });
  } else {
    (0, import_universal_analytics2.event)(newLaneProps);
  }
};
var trackAuth_default = trackAuth;

// src/tracking/sendExposure.ts
var import_universal_analytics3 = require("@zillow/universal-analytics");
var sendExposure = (exposureBlock) => {
  const properties = __spreadProps(__spreadValues({}, ExposureTypeStaticDataMapping.Exposure), {
    exposure: exposureBlock
  });
  (0, import_universal_analytics3.event)(properties);
};
var sendExposure_default = sendExposure;

// src/tracking/dom/constants.ts
var TARGET_DOM_NODE_TYPES = {
  /**
   * Set of node types targeted for interaction events.
   */
  Interaction: /* @__PURE__ */ new Set(["BUTTON", "A"]),
  /**
   * Set of node types targeted for impression events.
   */
  Impression: /* @__PURE__ */ new Set(["P", "SPAN"])
};
var isAuth0Prod = typeof window !== "undefined" && window.location.hostname === "identity.zillow.com";

// src/tracking/dom/domTextScanner.ts
function domTextScanner(targetTexts, targetNodeTypes) {
  return document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
    /**
     * Determines whether a node should be accepted or rejected during traversal.
     * Accepts when the node contains any of the target texts and any ancestor is a target node type.
     *
     * @param node - The node to evaluate.
     * @returns NodeFilter.FILTER_ACCEPT if the node meets the tracking criteria, otherwise NodeFilter.FILTER_REJECT.
     */
    acceptNode: (node) => {
      const isTargetText = targetTexts.has(node.nodeValue.trim());
      if (!isTargetText) {
        return NodeFilter.FILTER_REJECT;
      }
      let parent = node.parentNode;
      while (parent && parent !== document.body) {
        if (targetNodeTypes.has(parent.nodeName)) {
          return NodeFilter.FILTER_ACCEPT;
        }
        parent = parent.parentNode;
      }
      return NodeFilter.FILTER_REJECT;
    }
  });
}
function interactionTargetScanner(targetTexts) {
  return domTextScanner(targetTexts, TARGET_DOM_NODE_TYPES.Interaction);
}
function impressionTargetScanner(targetTexts) {
  return domTextScanner(targetTexts, TARGET_DOM_NODE_TYPES.Impression);
}

// src/tracking/dom/initTrackingSDK.ts
var import_universal_analytics4 = require("@zillow/universal-analytics");
var import_fflate = require("fflate");
function initTrackingSDK(auth0QueryParams) {
  window.fflate = { gzipSync: import_fflate.gzipSync, strToU8: import_fflate.strToU8 };
  const options = {
    zillow: {
      //this write key will be used as placeholder. This will get replaced by the actual writeKey from the query param
      writeKey: isAuth0Prod ? "auth0_prod_web_noop" : "auth0_dev_web_noop",
      apiHost: isAuth0Prod ? "cs.zg-api.com" : "cs.zg-api.test.zillow.net",
      secure: true,
      encodedExternalContext: auth0QueryParams
    }
  };
  const cdn = isAuth0Prod ? "https://js.zg-api.com/a/z/js/v1/analytics.js" : "https://js.zg-api.test.zillow.net/a/z/js/v1/analytics.js";
  (0, import_universal_analytics4.initZanalytics)(window, document, options, void 0, cdn);
}

// src/tracking/dom/trackingEventHandler.ts
function triggerImpressionEvents(eventTargetMapping) {
  const walker = impressionTargetScanner(new Set(Object.keys(eventTargetMapping)));
  let textNode;
  while (textNode = walker.nextNode()) {
    eventTargetMapping[textNode.nodeValue.trim()](textNode.nodeValue.trim());
  }
}
function attachInteractionEventHandlers(eventTargetMapping) {
  const walker = interactionTargetScanner(new Set(Object.keys(eventTargetMapping)));
  let textNode;
  while (textNode = walker.nextNode()) {
    let parent = textNode.parentNode;
    while (parent && !TARGET_DOM_NODE_TYPES.Interaction.has(parent.nodeName)) {
      parent = parent.parentNode;
    }
    if (parent) {
      parent.addEventListener("click", eventTargetMapping[textNode.nodeValue.trim()]);
    }
  }
}

// src/tracking/dom/initializeAuth0Tracking.ts
var getCookie = (name) => {
  const nameEQ = name + "=";
  const cookiesArray = document.cookie.split("; ");
  const cookieString = cookiesArray.find((cookie) => cookie.startsWith(nameEQ));
  if (cookieString !== void 0) {
    return cookieString.slice(nameEQ.length);
  }
  return null;
};
var getGuid = () => {
  var _a;
  const guidString = getCookie("zguid");
  if (guidString !== null) {
    return (_a = decodeURIComponent(guidString).split("|")[1]) == null ? void 0 : _a.slice("$".length);
  }
  return null;
};
var base64URLencode = (str) => {
  const base64Encoded = btoa(str);
  return base64Encoded.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};
var extractAuth0QueryParams = () => {
  const guid = getGuid();
  if (guid === null) {
    throw new Error("Unable to get guid from cookies");
  }
  const writeKey = isAuth0Prod ? "z_prod_web" : "z_dev_web";
  const queryParamValue = `${writeKey},${guid},,,`;
  return base64URLencode(queryParamValue);
};
function initializeAuth0Tracking({
  auth0QueryParams,
  pageViewEvent,
  impressionEventTargetMapping,
  interactionEventTargetMapping
}) {
  if (typeof window === "undefined") {
    console.error(
      "@zillow/auth-utils/tracking/dom/enableTracking is intended for browser use only and requires the window object."
    );
    return;
  }
  let clickstreamParams = auth0QueryParams;
  if (clickstreamParams === "") {
    try {
      clickstreamParams = extractAuth0QueryParams();
    } catch (error) {
      console.error(
        `Clickstream SDK is not initialized. auth0QueryParams must NOT be empty to enable Clickstream tracking.`,
        error
      );
      return;
    }
  }
  initTrackingSDK(clickstreamParams);
  if (!pageViewEvent && !interactionEventTargetMapping && !impressionEventTargetMapping) {
    console.log("No clickstream tracking enabled for this screen.");
    return;
  }
  if (pageViewEvent) {
    pageViewEvent();
  }
  if (impressionEventTargetMapping) {
    triggerImpressionEvents(impressionEventTargetMapping);
  }
  if (interactionEventTargetMapping) {
    attachInteractionEventHandlers(interactionEventTargetMapping);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AUTH_DEFAULT,
  AUTH_EVENT_TYPE,
  AUTH_METHOD,
  AUTH_TYPE,
  EXPOSURE_ASSIGNMENT_SERVICE,
  EXPOSURE_KEY_TYPE,
  EventTypeStaticDataMapping,
  ExposureTypeStaticDataMapping,
  IDP,
  INPUT_SELECTOR,
  NO_TRIGGER_OBJECT,
  TARGET_DOM_NODE_TYPES,
  TRIGGER_OBJECT,
  TRIGGER_TYPE,
  UNSPECIFIED,
  domTextScanner,
  getInputSelector,
  initializeAuth0Tracking,
  isAuth0Prod,
  pageView,
  sendExposure,
  trackAuth
});
